/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/251-hipster2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm3.497 6.615A1.507 1.507 0 018 9.5a1.491 1.491 0 01-.497 1.115C6.151 11.842 3 10.586 3 9c.969.625 1.726.153 2.439-.561a1.5 1.5 0 012.56 1.06 1.5 1.5 0 012.56-1.06c.713.714 1.471 1.186 2.439.561 0 1.586-3.151 2.842-4.503 1.615z"/>'
  }
})
